import FolderPaths, { BaseFolder } from '@/utils/images';

export type GreenroomPlaceholderShot = {
  order: number;
  shot_id: number;
  duration: string;
  duration_seconds: number;
  name: string;
  thumbnail_url?: BaseFolder;
};

export const GREENROOM_PLACEHOLDER_SHOTS: GreenroomPlaceholderShot[] = [
  {
    order: 1,
    shot_id: 1,
    duration: '0:13',
    duration_seconds: 13,
    name: 'Countdown',
    thumbnail_url: FolderPaths.GreenroomShotCountdown,
  },
  {
    order: 2,
    shot_id: 2,
    duration: '2:37',
    duration_seconds: 157,
    name: 'Intro',
    thumbnail_url: FolderPaths.GreenroomShotIntro,
  },
  {
    order: 3,
    shot_id: 3,
    duration: '0:06',
    duration_seconds: 6,
    name: 'Spotlight',
    thumbnail_url: FolderPaths.GreenroomShotSpotlight,
  },
  {
    order: 4,
    shot_id: 4,
    duration: '0:05',
    duration_seconds: 5,
    name: 'Q&A',
    thumbnail_url: FolderPaths.GreenroomShotSpotQandA,
  },
  {
    order: 5,
    shot_id: 5,
    duration: '0:05',
    duration_seconds: 5,
    name: 'Thanks!',
    thumbnail_url: FolderPaths.GreenroomShotSpotThanks,
  },
];
